module.exports = __webpack_public_path__ + "static/media/8796.f04b2ee2.png";